module.exports = __webpack_public_path__ + "images/iphone/map_button_pressed.png";